var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommissionDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_29878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7984 5.75C12.4375 5.37969 12.0563 5.05 11.6672 4.77031C11.6557 4.76185 11.6446 4.75359 11.6336 4.74551C11.5708 4.69917 11.5765 4.59782 11.6428 4.55657C12.1097 4.2659 12.4094 3.8034 12.4094 3.27969C12.4094 2.3625 11.5156 1.6625 10.4563 1.6625C10.2109 1.6625 9.9875 1.70469 9.78594 1.78125C9.68437 1.81563 9.6125 1.85156 9.55469 1.88594C9.52656 1.9 9.44688 1.87969 9.41719 1.84375C9.3375 1.725 9.21563 1.58437 9.04219 1.4375C8.74375 1.18437 8.39219 1.01875 8 0.984375C7.60781 1.01875 7.25625 1.18437 6.95469 1.43906C6.78125 1.58594 6.65938 1.72656 6.57969 1.84531C6.55156 1.87969 6.47187 1.90156 6.44219 1.8875C6.38437 1.85313 6.3125 1.81719 6.21094 1.78281C6.00938 1.70625 5.78594 1.66406 5.54063 1.66406C4.48125 1.66406 3.5875 2.36406 3.5875 3.28125C3.5875 3.80503 3.88567 4.26537 4.35052 4.55594C4.41746 4.59778 4.4222 4.70096 4.35947 4.74887C4.34968 4.75634 4.33976 4.76401 4.32969 4.77187C3.94063 5.05156 3.55937 5.38125 3.19844 5.75156C2.15781 6.82031 1.51562 8.05313 1.51562 9.41719C1.51562 13.2094 4.42656 15.0156 7.93594 15.0156H8.06406C11.5734 15.0156 14.4844 13.2094 14.4844 9.41719C14.4844 8.05313 13.8422 6.82031 12.7984 5.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01294 6V12",
    stroke: "#FF6900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51272 6.54492C9.51272 6.54492 8.14507 6.54492 7.46726 6.54492C6.78945 6.54492 6.23999 7.09439 6.23999 7.77219C6.23999 8.45 6.78945 8.99947 7.46726 8.99947",
    stroke: "#FF6900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51294 11.4545C6.51294 11.4545 7.88058 11.4545 8.55839 11.4545C9.2362 11.4545 9.78567 10.9051 9.78567 10.2273C9.78567 9.54946 9.2362 9 8.55839 9H7.46748",
    stroke: "#FF6900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_29878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionDetail);
export default __webpack_public_path__ + "static/media/commission-detail.500b9a4fcd834f07ec31db083d0b9c2d.svg";
export { ForwardRef as ReactComponent };